/** Base URL del bot atención mostrador (botrecetasatencion). */
export function resolveAtencionBotBaseUrl() {
  const raw = (process.env.REACT_APP_ATENCION_BOT_URL || '').trim().replace(/\/$/, '');
  if (raw) return raw;
  if (process.env.NODE_ENV === 'development') {
    return 'http://127.0.0.1:2000';
  }
  return '';
}

export const ATENCION_BOT_BASE_URL = resolveAtencionBotBaseUrl();

/** Normaliza celular AR a 10 dígitos (área + número, sin 0/15/549). */
export function normalizeSimPhoneDigits(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.length >= 10) return digits.slice(-10);
  return digits;
}

export function isValidSimPhoneDigits(digits) {
  const d = normalizeSimPhoneDigits(digits);
  return d.length === 10 && !/^0+$/.test(d);
}

export function simPhoneDigitsToE164(digits) {
  const d = normalizeSimPhoneDigits(digits);
  return isValidSimPhoneDigits(d) ? `+549${d}` : '';
}

const BF_SIM_LAST_PHONE_KEY = 'bf_sim_last_phone';

export function loadLastSimPhoneDigits() {
  try {
    const stored = normalizeSimPhoneDigits(localStorage.getItem(BF_SIM_LAST_PHONE_KEY));
    return isValidSimPhoneDigits(stored) ? stored : '';
  } catch {
    return '';
  }
}

export function saveLastSimPhoneDigits(digits) {
  try {
    const d = normalizeSimPhoneDigits(digits);
    if (isValidSimPhoneDigits(d)) {
      localStorage.setItem(BF_SIM_LAST_PHONE_KEY, d);
    }
  } catch {
    // ignore
  }
}
